import { I18n } from "utils/i18n-shim"

export const EU_COUNTRIES_ALPHA2 = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE"
]

export const DE_COUNTRY_CODE = "DE"

export const DEFAULT_COUNTRY = { id: "de", name: DE_COUNTRY_CODE }

export const getCountryLabel = (country) =>
  country.id ? I18n.t(`countries.${country.name}`) : I18n.t("all")

export const formatCountry = (country) => {
  return I18n.t(`countries.${country.name.toUpperCase()}`)
}

export const isGermanCountry = (countryCode) => {
  if (!countryCode) return false
  return countryCode.toUpperCase() === DE_COUNTRY_CODE
}

export const isEUCountry = (countryCode) => {
  if (!countryCode) return false
  return EU_COUNTRIES_ALPHA2.includes(countryCode.toUpperCase())
}
